import { useEffect } from "react";
import { useNavigate } from "react-router";
import queryString from "query-string";

import { useToast } from "@vega-core/components/Toast/useToast";
import { useStatusPopup } from "@vega-core/hooks/useStatusPopup";
import { m } from "@vega-core/paraglide/messages";
import { isTruthy } from "@vega-core/utils/isTruthy";

const WRONG_OKTA_ACCOUNT_ERROR =
  "User is not assigned to the client application.";

export const useOktaError = () => {
  const navigate = useNavigate();

  const showToast = useToast();
  const { setError } = useStatusPopup();

  useEffect(
    function checkQueryError() {
      const params = queryString.parse(location.search);

      if (isTruthy(params.error)) {
        setError({
          description:
            params.error_description === WRONG_OKTA_ACCOUNT_ERROR
              ? m.auth_oktaWrongAccount()
              : (params.error_description as string),
          title: m.status_error(),
        });

        navigate("/login");
      }
    },
    [navigate, setError, showToast],
  );
};
